<div class="announcements-container">
  <div #marqueeContainer class="marquee-container">
    <div #marqueeContent class="marquee-content">
      <ng-container *ngFor="let announcement of infiniteAnnouncements(); let i = index">
        <span class="announcement-text">{{ announcement }}</span>
        <span class="separator" *ngIf="i < infiniteAnnouncements().length - 1">•</span>
      </ng-container>
    </div>
  </div>
  
  <div class="no-announcements" *ngIf="activeAnnouncements().length === 0">
    <p>No active announcements</p>
  </div>
</div>
